import React from "react";
import { IAffiliateDashboard } from "./types";
import { Address, Card, Table, TableScroll } from "./style";
import { dateLabel } from "./fees";

export default function FillHistory({
  fills,
  accountLabel,
  limit = 25,
  rewardPolicy,
}: {
  fills: IAffiliateDashboard["fills"];
  accountLabel?: (account: string) => string;
  limit?: number;
  rewardPolicy?: string;
}) {
  const cashPointsOnly = rewardPolicy === "cash_points_v1";
  const showDao =
    !cashPointsOnly ||
    fills.some((fill) => Number(fill.accrual.dao_aevo_usd) > 0);
  return (
    <Card>
      <h2>Trading earnings</h2>
      <p>
        Your rewards from completed trades.
        {cashPointsOnly
          ? " New trades earn USDC commission and points only."
          : " DAO rewards are shown as their USD value and remain unpaid until delivered."}
        {cashPointsOnly && showDao && " Historical DAO values remain unpaid."}
      </p>
      {fills?.length ? (
        <TableScroll>
          <Table>
            <thead>
              <tr>
                <th>Trader</th>
                <th>Time</th>
                <th>Fee paid</th>
                <th>Waived</th>
                <th>Cash</th>
                {showDao && (
                  <th>
                    {cashPointsOnly ? "Historical DAO value" : "DAO value"}
                  </th>
                )}
                <th>Points</th>
              </tr>
            </thead>
            <tbody>
              {[...fills]
                .sort(
                  (a, b) => Date.parse(b.request.at) - Date.parse(a.request.at)
                )
                .slice(0, limit)
                .map((fill) => (
                  <tr key={`${fill.request.wallet}:${fill.request.fill_id}`}>
                    <td title={fill.request.fill_id}>
                      <Address title={fill.request.wallet}>
                        {accountLabel?.(fill.request.wallet) ||
                          `${fill.request.wallet.slice(
                            0,
                            6
                          )}…${fill.request.wallet.slice(-4)}`}
                      </Address>
                    </td>
                    <td>{dateLabel(fill.request.at)}</td>
                    <td>${fill.fee_paid}</td>
                    <td>${fill.fee_waived}</td>
                    <td>${fill.accrual.cash_usd}</td>
                    {showDao && <td>${fill.accrual.dao_aevo_usd}</td>}
                    <td>{fill.accrual.earned_points}</td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </TableScroll>
      ) : (
        <p>
          No trading earnings yet. Invite a trader with your referral link to
          get started.
        </p>
      )}
    </Card>
  );
}
